if (typeof window === 'undefined') {
    var window = {}
}

// Hungarian colour names for NFC card subtypes.
const nfc_subtype_hu = {
    black:  'fekete',
    carbon: 'szénszálas',
    white:  'fehér',
    silver: 'ezüst',
    gold:   'arany',
    bamboo: 'bambusz',
}

// Format a HUF amount with space thousands separators, e.g. 10000 -> "10 000".
function hufFormat(n) {
    return ('' + (parseInt(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

function productNameShort(o, language='hu') {
    const product_name = {
        businesscard: 'Névjegy',
        calendarA3: 'A3 Fali',
        calendarA4: 'A4 Fali',
        calendardesktop: 'Asztali',
        photobook: 'Könyv',
        photobooklet: 'Füzet',
        photoalbum: 'Album',
        rug: 'Szőnyeg',
        photo: 'Fényk.t',
    }
    const pb_format = {
        '15x15': '15x15cm',
        '20x20': '20x20cm',
        '20x29': 'A4',
        '29x29': 'ÓRIÁS',
    }
    let product = o.item.settings.product
    let format = o.item.settings.format
    let nPages = o.item.activePages

    let name = product + ' ' + format
    if (product == 'businesscard') {
        name = product_name[product] + ' ' + format + 'mm'
    } else if (product == 'photobook') {
        let pbpages = (nPages - 1) * 2
        let make = o.item.settings.make ? o.item.settings.make : (pbpages <= 40 ? 'booklet' : 'book')
        name = pbpages + 'o. ' + pb_format[format] + ' ' + product_name['photo' + make]
    } else if (product == 'calendar') {
        name = product_name[product+format]
    } else if (product == 'photo') {
        name = product_name[product]
    } else if (product == 'regular') {
        let sku = o.item.settings.sku
        let subtype = o.item.settings.subtype
        if (sku == 'nfc') {
            name = 'NFC kártya - ' + (nfc_subtype_hu[subtype] || subtype || '')
        } else if (sku == 'voucher') {
            name = 'Utalvány - ' + hufFormat(subtype) + ' Ft'
        } else {
            name = o.item.quote.name || sku
        }
    } else if (product == 'other') {
        name = o.item.quote.name
    } else {
        name = product_name[product] + ' ' + format + 'cm'
    }
    return name
}
window.productNameShort = productNameShort

function productName(o, language='hu') {
    const product_name = {
        businesscard: 'Névjegykártya',
        calendarA3: 'A3 Falinaptár',
        calendarA4: 'A4 Falinaptár',
        calendardesktop: 'Asztali naptár',
        photobook: 'Fotókönyv',
        photobooklet: 'Fotófüzet',
        photoalbum: 'Fotóalbum',
        rug: 'Szőnyeg',
        photo: 'Fényképes termék',
    }
    const pb_format = {
        '15x15': '15x15cm',
        '20x20': '20x20cm',
        '20x29': 'A4',
        '29x29': 'ÓRIÁS',
    }
    let product = o.item.settings.product
    let format = o.item.settings.format
    let nPages = o.item.activePages

    let name = product + ' ' + format
    if (product == 'businesscard') {
        name = format + 'mm ' + product_name[product]
    } else if (product == 'photobook') {
        let pbpages = (nPages - 1) * 2
        let make = o.item.settings.make ? o.item.settings.make : (pbpages <= 40 ? 'booklet' : 'book')
        name =  pbpages + 'oldalas ' + pb_format[format] + ' ' + product_name['photo' + make]
    } else if (product == 'calendar') {
        name = product_name[product+format]
    } else if (product == 'photo') {
        name = product_name[product]
    } else if (product == 'regular') {
        let sku = o.item.settings.sku
        let subtype = o.item.settings.subtype
        if (sku == 'nfc') {
            name = 'NFC kártya' + (subtype ? ' - ' + (nfc_subtype_hu[subtype] || subtype) : '')
        } else if (sku == 'voucher') {
            name = 'Ajándékutalvány - ' + hufFormat(subtype) + ' Ft'
        } else {
            name = o.item.quote.name || sku
        }
    } else if (product == 'other') {
        name = o.item.quote.name
    } else {
        name = format + 'cm '  + product_name[product]
    }
    return name
}
window.productName = productName

function paymentType(o, language='hu') {
    const ptypes = {
        cod: {title: 'Utánvét'}, // postpaid_regular volt
        wiretransfer: {title: 'Átutalás'},
        paypal: {title: 'Bankkártya (PayPal)'},
        skrill: {title: 'Bankkártya (Skrill)'}, // moneybookers volt
        stripe: {title: 'Bankkártya (Stripe)'},
        simple: {title: 'Bankkártya (SimplePay)'},
        barion: {title: 'Bankkártya (Barion)'},
        cash: {title: 'Készpénz (Telephely)'},
        cash_pos: {title: '* Bankkártya (Telephely)'},
        wiretransfer_office: {title: '* Átutalás (Telephely)'}, // office_wire volt
    }
    let ptype = o.payment_type
    ptype = ptypes[ptype]
    if (ptype) {
        return ptype.title
    } else {
        return "Egyéb"
    }
}
window.paymentType = paymentType


export { productName, productNameShort, paymentType }
